"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _SvgInSelectArrow = require("../svg/interface/SvgInSelectArrow");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children", "classes", "arrow", "open", "disabled"];
(0, _loadStyles.default)(".c8b2da198{outline:0;border:0;overflow:visible;-webkit-user-select:none;-ms-user-select:none;user-select:none;padding:.625rem;max-width:100%;box-sizing:border-box;cursor:pointer;display:inline-flex;align-items:center;background:#f6f6f6;font-size:.875rem;font-weight:500;line-height:1rem;border-radius:.625rem;color:var(--color-flomni-gray-90)}.c8b2da198:hover{opacity:.7}.c8b2da198:active{opacity:.5}.cafcd4d0a{opacity:.3;cursor:default}.cafcd4d0a:hover{opacity:.3}.cafcd4d0a:active{opacity:.3}.c9a49f71b{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.c3157e1f5{margin-left:.375rem;width:.5625rem;min-width:.5625rem;display:flex;align-items:center;color:var(--color-flomni-gray-40);transition:-webkit-transform var(--animation-timing-def) ease;transition:transform var(--animation-timing-def) ease;transition:transform var(--animation-timing-def) ease,-webkit-transform var(--animation-timing-def) ease}.c5348fd43{-webkit-transform:rotate(180deg);transform:rotate(180deg)}");
var styles = {
  root: 'c8b2da198',
  '--disabled': 'cafcd4d0a',
  children: 'c9a49f71b',
  icon: 'c3157e1f5',
  '--open': 'c5348fd43'
};

var DropButton = function DropButton(props) {
  var children = props.children,
      classes = props.classes,
      arrow = props.arrow,
      open = props.open,
      disabled = props.disabled,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.disabled, disabled)),
    disabled: disabled
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.children
  }, children), !arrow ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.icon, (0, _defineProperty2.default)({}, cn.open, open))
  }, /*#__PURE__*/_react.default.createElement(_SvgInSelectArrow.SvgInSelectArrow, null)));
};

exports.DropButton = DropButton;
DropButton.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  arrow: _propTypes.bool,
  open: _propTypes.bool,
  disabled: _propTypes.bool,

  /* styling modificators */

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
DropButton.defaultProps = {
  arrow: true,
  disabled: false,
  open: false,
  classes: {}
};